export default __webpack_public_path__ + "static/media/c62479f4fa6c991f6e2ee7448e6e49b81581611583309.3c8ff8fd.webp";